import { Box, Button, IconButton, Paper, styled } from "@mui/material";

export const StyledXML = {
    Title: styled("div")({
        color: "#484848",
        marginBottom: "8px",
        fontFamily: "Roboto, sans-serif",
        fontSize: "large",
        fontWeight: 500,
    }),
    Content: styled("div")({
        fontSize: "16px",
        lineHeight: "1.5",
    }),
    Paper: styled(Paper)({
        display: "flex",
        padding: 20,
        marginBottom: 20,
    }),
    CodeContainer: styled(Box)({
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "12px"
    }),
    InputContainer: styled(Box)({
        width: "100%",
        display: "flex",
        gap: "12px"
    }),
    PasteButton: styled(Button)(({ theme }) => ({
        marginTop: theme.spacing(1),
    })),
    TextAreaButton: styled(IconButton)(({ theme }) => (
        {
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
            }
        }
    ))
};

export const StyledXMLNews = {
    XmlVisualizer: styled(Box)(() => ({
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        backgroundColor: '#f5f5f5',
        padding: '16px',
        borderRadius: '4px',
        maxHeight: '500px',
        overflow: 'auto'
    }))
}